import React, { useEffect, useRef, useState } from "react";

const Preloader = ({ onDone }) => {
  const [count, setCount] = useState(0);
  const [exiting, setExiting] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const duration = reduce ? 600 : 1800;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(Math.round(eased * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else {
        setExiting(true);
        setTimeout(() => onDone && onDone(), reduce ? 200 : 900);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <div
      ref={rootRef}
      data-testid="preloader"
      className={`fixed inset-0 z-[100] flex items-end justify-between px-6 md:px-12 pb-10 md:pb-14 transition-[clip-path] duration-[1100ms]`}
      style={{
        background: "#f2f2f0",
        clipPath: exiting ? "inset(0 0 100% 0)" : "inset(0 0 0 0)",
        transitionTimingFunction: "cubic-bezier(0.77, 0, 0.175, 1)",
      }}
    >
      <div className="flex flex-col gap-3">
        <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">Delventure</span>
        <span className="text-xs tracking-[0.25em] uppercase text-muted-ink">Initializing</span>
      </div>
      <div className="flex items-end gap-3">
        <span className="font-display text-[18vw] md:text-[10vw] leading-none font-bold text-[#0a0a0b]">
          {String(count).padStart(3, "0")}
        </span>
        <span className="text-xs tracking-[0.3em] uppercase text-muted-ink pb-4 md:pb-6">/ 100</span>
      </div>
    </div>
  );
};

export default Preloader;
